import { useEffect } from 'react';

import { Backdrop, Button, Dialog, DialogProps, Grid, Typography } from '@mui/material';
import { X } from 'phosphor-react';
import { useEvent } from 'react-use';

import { primaryColors } from '~components/theme/styles/colors';

import { useAccountDial } from '../accountDial/provider';

export const FullDialog: React.FC<
  DialogProps & { title: string; handleClose?: () => void; centerContent?: boolean }
> = ({ open, title, children, handleClose, centerContent = false, ...props }) => {
  const { setIsFullscreen, dialOpen } = useAccountDial();

  useEffect(() => {
    if (open) {
      setIsFullscreen(true);
    }
  }, [open]);

  const handleCloseAndFullScreen = () => {
    if (!dialOpen) {
      setIsFullscreen(false);
      handleClose ? handleClose() : null;
    }
  };

  const onKeydown = ({ key }: { key: string }) => {
    if (key === 'Escape') {
      handleCloseAndFullScreen();
    }
  };

  useEvent('keyup', onKeydown);

  return (
    <Dialog fullScreen open={open} {...props}>
      <Backdrop
        sx={{
          width: '100vw',
          background: 'linear-gradient(47.42deg, #171717 49.75%, rgba(23, 23, 23, 0) 77.72%), #262626',
          backgroundSize: 'cover',
        }}
        open
      />
      <Grid
        container
        sx={{
          flexDirection: 'column',
          position: 'relative',
          width: '100%',
          height: '100%',
          flexWrap: 'initial',
        }}
      >
        <Grid
          item
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            maxWidth: '1088px',
            color: primaryColors[700],
            margin: 'auto',
            marginTop: ['48px', '64px'],
            padding: ['0 24px', '0'],
          }}
        >
          <Grid item>
            <Typography variant="label2" color={primaryColors[700]}>
              {title}
            </Typography>
          </Grid>
          {handleClose && (
            <Grid item>
              <Button
                sx={{ color: primaryColors[700], padding: 0, minWidth: 0 }}
                onClick={handleCloseAndFullScreen}
              >
                <X size={32} />
              </Button>
            </Grid>
          )}
        </Grid>
        <Grid container item xs={12} sx={{ alignItems: centerContent ? 'center' : 'start' }}>
          {children}
        </Grid>
      </Grid>
    </Dialog>
  );
};
